import { ApiClient } from "./clients";
import { Dependency, ListService } from "@/types";

export const DependenciesService: ListService<Dependency> = {
  async add(entity: Dependency, request) {
    return await ApiClient.post<Dependency>(
      "/api/v1/dependencies/",
      entity,
      false,
      request
    );
  },
  async update(entity: Dependency, columns: any, request) {
    return await ApiClient.put<Dependency>(
      `/api/v1/dependencies/${entity.id}/`,
      columns,
      request
    );
  },
};
